module.exports = __webpack_public_path__ + "img/neo-tips-300x121.b2705b3d.png";